import styles from './TableCardView.module.scss';
import { Space } from 'antd';
import type { SortOrder } from 'antd/lib/table/interface';
import type { TableColumnType } from '../Table';
import { TableCardViewFilterControls } from './TableCardViewFilterControls';
import { TableCardViewSortControls } from './TableCardViewSortControls';

export interface CardSortState {
  key?: string;
  order?: SortOrder;
}

export type CardFilterState = Record<string, string | undefined>;

interface Props<T> {
  sortableColumns: TableColumnType<T>[];
  filterableColumns: TableColumnType<T>[];
  sort: CardSortState;
  onSortChange: (sort: CardSortState) => void;
  filters: CardFilterState;
  onFiltersChange: (filters: CardFilterState) => void;
  columnsControl?: React.ReactNode;
}

export function TableCardViewControls<T>(props: Props<T>) {
  const {
    sortableColumns,
    filterableColumns,
    sort,
    onSortChange,
    filters,
    onFiltersChange,
    columnsControl,
  } = props;

  return (
    <Space direction="vertical" size="small" className={styles.controls}>
      {columnsControl && (
        <div className={styles.columnsControl}>{columnsControl}</div>
      )}
      {sortableColumns.length > 0 && (
        <TableCardViewSortControls
          columns={sortableColumns}
          sort={sort}
          onSortChange={onSortChange}
        />
      )}

      {filterableColumns.length > 0 && (
        <TableCardViewFilterControls
          columns={filterableColumns}
          filters={filters}
          onFiltersChange={onFiltersChange}
        />
      )}
    </Space>
  );
}
